import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

import { Button, Description, Title } from './PopoverContent.styled';

type PopoverContent = {
  SC_COACHMARK: {
    title: string;
    message: string;
  };
  onCloseCoachmarkWeb: () => void;
};

const PopoverContent: React.FC<PopoverContent> = ({
  SC_COACHMARK = {
    title: '',
    message: '',
  },
  onCloseCoachmarkWeb = () => {},
}) => (
  <>
    {/* Custom close icon in top-right */}
    <Button
      aria-label="Close"
      className="abyss-popover-close-button"
      data-testid="smart-choice-coachmark-close-button"
      onClick={() => {
        onCloseCoachmarkWeb();
      }}
    >
      <IconSymbol icon="close" size={22} />
    </Button>
    {/* Popover title content */}
    <Title>{SC_COACHMARK?.title}</Title>
    {/* Popover message content */}
    <Description>{SC_COACHMARK?.message}</Description>
  </>
);

export default PopoverContent;
